export default {
  title: '! Orders paused until {{time}}',
  button: 'Unpause',
  labels: {
    rest_of_day: 'rest of day',
  },
};
